import { putSearches } from '~/api';
import { useHandleException } from '~/scripts/handleException';
import { isEmptySearch } from '~/scripts/isEmptySearch';
import type { Searches } from '~/types/searches';
import { useQuery } from './useQuery';

export const usePutSearch = (search: Searches.SearchObject | null) => {
  const handleException = useHandleException();
  return useQuery({
    queryKey: [search],
    async queryFn() {
      if (!search || isEmptySearch(search)) {
        return null;
      }
      return putSearches(search);
    },
    onError(error) {
      handleException(error, {
        category: 'ReportPage.tsx',
      });
    },
  });
};
